import initialState from './initialState';
import * as types from '../constants/actionTypes';
import RhpStoreImage from 'redhotpie-shared-lib/models/rhpStoreImage';
import RhpStoreOrder from 'redhotpie-shared-lib/models/rhpStoreOrder';
import { Immutable, ImmutableObject } from 'seamless-immutable';

export interface IRhpStoreCard {
  isShowCartView: boolean;
  isLoading: boolean;
  infoCart: RhpStoreOrder | null;
}

export interface IRhpStoreState {
  cart: IRhpStoreCard;
  storeItemSelected: RhpStoreOrder | null;
  imageStore: {
    isLoading: boolean;
    data: {
      [productId: number]: RhpStoreImage[];
    };
  };
  storeItems: {
    isLoading: boolean;
    data: any;
  };
  yourDiamonds: number;
  orderDetail: {
    infoOrder: any;
  };
  productCategory: any;
}

export type RhpStoreAction = {
  type: string;
  data?: any;
  params?: any;
  key?: string[];
  value?: any;
  productId?: number;
};

export default function rhpStoreReducer(state: ImmutableObject<IRhpStoreState> = initialState.rhpStore, action: RhpStoreAction) {
  switch (action.type) {
    case types.TOGGLE_CART_VIEW_SUCCESS:
      return state.setIn(['cart', 'isShowCartView'], !!action.data);
    case types.SELECT_PRODUCT_ITEM_SUCCESS:
      return state.set('storeItemSelected', action.data); // storeItemSelected is RhpStoreOrder model
    case types.GET_USER_CURRENT_STORE_ORDER_REQUEST:
      return state.setIn(['cart', 'isLoading'], true);
    case types.GET_USER_CURRENT_STORE_ORDER_FAILED:
      return state.setIn(['cart', 'isLoading'], false);
    case types.GET_USER_CURRENT_STORE_ORDER_SUCCESS:
      return state.setIn(['cart', 'infoCart'], action.data).setIn(['cart', 'isLoading'], false);
    case types.GET_STORE_PRODUCT_IMAGE_REQUEST:
      return state.setIn(['imageStore', 'isLoading'], true);
    case types.GET_STORE_PRODUCT_IMAGE_FAILED:
      return state.setIn(['imageStore', 'isLoading'], false);
    case types.GET_STORE_PRODUCT_IMAGE_SUCCESS:
      return state.setIn(['imageStore', 'data', `${action.productId}`], action.data).setIn(['imageStore', 'isLoading'], false);
    case types.GET_STORE_PRODUCTS_REQUEST:
      return state.setIn(['storeItems', 'isLoading'], true);
    case types.GET_STORE_PRODUCTS_FAILED:
      return state.setIn(['storeItems', 'isLoading'], false);
    case types.GET_STORE_PRODUCTS_SUCCESS:
      return state.setIn(['storeItems', 'isLoading'], false).setIn(['storeItems', 'data'], action.data);
    case types.GET_USER_STORE_CREDITS_SUCCESS:
      return state.setIn(['yourDiamonds'], (action.data && action.data.yourDiamonds) || 0);
    case types.UPDATE_STATE_RHP_STORE:
      return state.merge({ ...action.params });
    case types.GET_USER_ORDER_DETAIL_SUCCESS:
      return state.setIn(['orderDetail', 'infoOrder'], action.data);
    case types.UPDATE_STATE_RHP_STORE_WITH_KEY:
      return state.setIn([...(action.key as string[])], action.value);
    case types.UPDATE_STORE_PRODUCT_CATEGORY:
      return state.setIn(['productCategory'], action.data);
    case types.USER_LOGOUT_SUCCESS:
      return initialState.rhpStore;
    default:
      return state;
  }
}
